// extracted by mini-css-extract-plugin
export default {"ctn":"header_ctn__HIEPe","watchVideoButton":"header_watchVideoButton__l3y76"};